module.exports = __webpack_public_path__ + "22.862fb699.png";